export default {
      id: "coffee-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#coffee-usage",
      toString: function () {
        return this.url;
      }
    }